import React from 'react';
import {
  XMarkIcon,
  ListBulletIcon,
  PlusIcon,
  SparklesIcon,
} from '@heroicons/react/24/outline';

interface ChatHeaderProps {
  title: string | null;
  showSessionList: boolean;
  onToggleSessionList: () => void;
  onNewSession: () => void;
  onClose: () => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
  title,
  showSessionList,
  onToggleSessionList,
  onNewSession,
  onClose,
}) => {
  return (
    <div className="flex items-center justify-between px-3 py-2.5 bg-primary-600 text-white rounded-t-xl">
      <div className="flex items-center space-x-2 min-w-0">
        <SparklesIcon className="h-5 w-5 flex-shrink-0" />
        <span className="text-sm font-medium truncate">
          {showSessionList ? 'Conversazioni' : (title || 'Assistente AI')}
        </span>
      </div>
      <div className="flex items-center space-x-1">
        <button
          onClick={onToggleSessionList}
          className="p-1.5 rounded-md hover:bg-primary-500 transition-colors"
          title={showSessionList ? 'Torna alla chat' : 'Sessioni'}
        >
          <ListBulletIcon className="h-4 w-4" />
        </button>
        <button
          onClick={onNewSession}
          className="p-1.5 rounded-md hover:bg-primary-500 transition-colors"
          title="Nuova conversazione"
        >
          <PlusIcon className="h-4 w-4" />
        </button>
        <button
          onClick={onClose}
          className="p-1.5 rounded-md hover:bg-primary-500 transition-colors"
          title="Chiudi"
        >
          <XMarkIcon className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default ChatHeader;
